export default "__VITE_ASSET__CFed6p$4__"